import { createTheme, Direction } from '@mui/material/styles';
import type { CompanyThemeOptions } from './getCompanyThemeOptions';
import { createSportsDistrictThemeExtension } from './sportsDistrictTypography';

const DEFAULT_FONT_FAMILY = ['Roboto', 'sans-serif'].join(', ');

/** `direction` is 'rtl' only for the DFC village in Arabic — see `src/theme/dfcDirection.tsx`. */
export const createCustomTheme = (
  primaryColor: string,
  options?: CompanyThemeOptions,
  direction: Direction = 'ltr'
) => {
  const regularWeight = options?.useRegularFontWeight ? 400 : undefined;
  const isSportsDistrict = Boolean(options?.useRegularFontWeight);
  const sportsDistrict = createSportsDistrictThemeExtension(isSportsDistrict);

  return createTheme({
    direction,
    sportsDistrict,
    palette: {
      primary: {
        main: primaryColor,
      },
    },
    typography: {
      fontFamily: options?.fontFamily ?? DEFAULT_FONT_FAMILY,
      htmlFontSize: options?.htmlFontSize ?? 16,
      ...(regularWeight !== undefined && {
        fontWeightLight: regularWeight,
        fontWeightRegular: regularWeight,
        fontWeightMedium: regularWeight,
        fontWeightBold: regularWeight,
      }),
    },
    ...(regularWeight !== undefined && {
      components: {
        MuiButton: {
          styleOverrides: {
            root: {
              fontWeight: regularWeight,
            },
          },
        },
        MuiTypography: {
          styleOverrides: {
            root: {
              fontWeight: regularWeight,
            },
          },
        },
      },
    }),
  });
};
